<template>
  <div  
    class="app-content-container mx-auto h-full"
    :class="{'app-content-container-boxed': appContentWidth === 'boxed'}"
  >
  <slot></slot>
  </div>
  
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import { ref,   onMounted } from 'vue'
export default {
  setup() {
    const { appContentWidth } = useAppConfig()

    const menuIsMenuHidden = ref(false)

  
    return {
      appContentWidth,
      menuIsMenuHidden,
    }
  },
}






</script>

<style lang="scss">
@import '~@core/layouts/styles/_variables';

.app-content-container {
  &.app-content-container-boxed {
    max-width: $content-max-width;
  }
}

.app-content-container {
  padding-top: 0.5rem !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-bottom: 0rem !important;
}
</style>
